import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Rollback-controlled feature flag for the V3 adaptive assessment path.
 * Source of truth is engine_rules.v3_assessment_default (server-side).
 */
export function useV3AssessmentEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: ["v3-assessment-enabled"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("v3_assessment_enabled");
      if (error) return false;
      return Boolean(data);
    },
    staleTime: 5 * 60 * 1000,
  });
  return { v3Enabled: data === true, v3FlagLoading: isLoading };
}
